import gql from "graphql-tag";

// Clients
const GET_CLIENTS = gql`
    query MyQuery {
        spendmd_db_clients(order_by: { name: asc }) {
            name
            id
            description
            users(
                where: {
                    role_id: {
                        _in: [
                            "437af92a-dcbe-4e9e-bc80-b6d363c28440"
                            "64f760ef-8a81-4f10-a6b5-bdd399faf082"
                        ]
                    }
                }
            ) {
                account_disabled
                id
                name
                email
            }
        }
    }
`;

const GET_CLIENTS_LIST = gql`
    query MyQuery {
        spendmd_db_clients(where: { name: { _neq: "UAT" } }) {
            id
            name
        }
    }
`;

const INSERT_CLIENT = gql`
    mutation (
        $name: String!
        $description: String!
        $added: timestamp!
        $updated: timestamp!
        $userName: String!
        $userEmail: String!
    ) {
        insert_spendmd_db_clients(
            objects: {
                name: $name
                description: $description
                added: $added
                updated: $updated
                users: {
                    data: {
                        name: $userName
                        email: $userEmail
                        added: $added
                        updated: $updated
                        role_id: "437af92a-dcbe-4e9e-bc80-b6d363c28440" # client_admin role
                    }
                }
            }
        ) {
            returning {
                name
                id
                description
                users_aggregate {
                    aggregate {
                        count
                    }
                }
            }
        }
    }
`;

const UPDATE_CLIENT = gql`
    mutation (
        $client_id: uuid!
        $user_id: uuid!
        $description: String!
        $updated: timestamp!
        $userName: String!
        $userEmail: String!
        $client_name: String!
    ) {
        update_spendmd_db_clients(
            where: { id: { _eq: $client_id } }
            _set: {
                description: $description
                updated: $updated
                name: $client_name
            }
        ) {
            returning {
                id
            }
        }
        update_spendmd_db_users(
            where: { id: { _eq: $user_id } }
            _set: { name: $userName, email: $userEmail }
        ) {
            affected_rows
        }
    }
`;

const CHANGE_CLIENT_STATUS = gql`
    mutation (
        $client_id: uuid!
        $account_disabled: Boolean!
        $updated: timestamp!
    ) {
        update_spendmd_db_users(
            where: { client_id: { _eq: $client_id } }
            _set: { account_disabled: $account_disabled, updated: $updated }
        ) {
            returning {
                id
            }
        }
    }
`;

// Users
const GET_USERS = gql`
    query MyQuery($client_id: uuid!) {
        spendmd_db_users(
            where: { client_id: { _eq: $client_id } }
            order_by: { name: asc }
        ) {
            name
            id
            account_disabled
            client_id
            email
            image
            is_rejected
            role {
                name
            }
            client {
                name
            }
            verification_pending
        }
    }
`;

const ADD_GROUP_ASSIGNMENT = gql`
    mutation AddGroupAssignment($clients: json!, $users_id: uuid!) {
        spendmd_db_add_group_assignment(
            args: { clients: $clients, users_id: $users_id }
        ) {
            id
        }
    }
`;

const GET_CHECKED_CLIENTS = gql`
    query ($users_id: uuid!) {
        spendmd_db_get_checked_clients(args: { users_id: $users_id }) {
            client_id
            client_name
            is_grouped
        }
    }
`;

export default {
    GET_CLIENTS,
    INSERT_CLIENT,
    UPDATE_CLIENT,
    CHANGE_CLIENT_STATUS,
    GET_USERS,
    GET_CLIENTS_LIST,
    ADD_GROUP_ASSIGNMENT,
    GET_CHECKED_CLIENTS,
};
